<template>
  <div class="modalChart">
    <div class="chartPie">
      <apexchart
        ref="chart"
        type="donut"
        :options="chartOptions"
        :series="getSeries"
      ></apexchart>
    </div>
  </div>
</template>
<script>
export default {
  name: "apexchartPie",
  props: {
    questionData: {
      type: Object
    }
  },
  data() {
    return {
      series: this.questionData.summary,
      chartOptions: {
        labels: this.questionData.text,

        plotOptions: {
          pie: {
            donut: {
              size: "40%",
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: "20px",
                  fontFamily: "sans-Serif"
                },
                value: {
                  show: true
                },
                total: {
                  show: true,
                  showAlways: true
                }
              }
            }
          }
        },
        dataLabels: {
          style: {
            fontFamily: "sans-serif",
            fontSize: "1rem"
          }
        },
        legend: {
          position: "top"
        }
      }
    };
  },
  computed: {
    getSeries() {
      let series = this.questionData.summary;

      return series;
    }
  }
};
</script>
<style lang="scss">
.modalChart {
  display: flex;

  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/charts/ApexChartPie.vue